var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "36 57 43 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1367 59.5874L49.1525 78.9923L38.6768 87.5316L44.4592 68.4494L55.1367 59.5874ZM59.339 99.5L70.1577 90.6515L49.8047 79.3958L38.8314 88.1838L59.339 99.5ZM76.3234 70.7153L70.5611 89.9656L50.0266 78.6898L56.0242 59.5L76.3167 70.7221L76.3234 70.7153ZM70.8233 72.4904L58.6936 65.8607L55.298 77.1836L67.2664 83.8133L70.8233 72.4904Z",
    fill: "#1A56FF",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoc);
export default __webpack_public_path__ + "static/media/WOC.8d1ca2822e7433014e44f38b3fd15a7b.svg";
export { ForwardRef as ReactComponent };